<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-input v-model="form.responsiblePersonName" placeholder="资产负责人" style="width: 120px"/>
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form.assetCode" placeholder="资产编码" style="width: 120px"/>
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form.financialCode" placeholder="财务编码" style="width: 120px"/>
            </a-form-model-item>
            <a-form-model-item>
              <a-select v-model="form.status" placeholder="资产状态" style="width: 120px">
                <a-select-option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                placeholder="资产位置(部门)"
                show-search
                :filter-option="$selectFilterOption"
                v-model="form.deptId"
                style="width: 150px"
                @change="
                  () => {
                    text.deptName =
                      productionDepartmentList.find((item) => item.id === text.deptId)
                        ?.uniqueName || '';
                  }
                "
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form.brandModel" placeholder="品牌型号" style="width: 120px"/>
            </a-form-model-item>
            
            <a-form-model-item>
              <a-range-picker
                style="width: 250px"
                v-model="form.purchaseTime"
                :placeholder="['采购日期开始', '采购日期结束']"
              />
            </a-form-model-item>
            <a-form-model-item>
              <a-range-picker
                style="width: 250px"
                v-model="form.startTime"
                :placeholder="['启用日期开始', '启用日期结束']"
              />
            </a-form-model-item>
            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button style="margin-right: 10px" @click="batchReceive">批量接收</a-button>
              <a-button style="margin-right: 10px" @click="batchHandover">批量移交</a-button>
              <a-button
                v-if="$getPermission($route.path + '/add') && !isPerson"
                @click="$router.push($route.path + '/add')"
                type="primary"
                >新建</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        rowKey="id"
        :row-selection="{
          selectedRowKeys,
          onChange: onSelectChange,
        }"
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
        <a-table-column title="资产类别">
          <template slot-scope="text">
            <div style="display: flex;align-items: center">
              <DataDictFinder
              dictType="fixed_asset_type"
              :dictValue="text.category.categoryCode"
            />-
            {{text.category.subCategoryName}}
            </div>
          </template>
        </a-table-column>
        <a-table-column title="品牌型号" data-index="brandModel"> </a-table-column>
        <a-table-column title="采购日期" data-index="procurementTime"> </a-table-column>
        <a-table-column title="采购价格(元)" data-index="purchasePrice"> </a-table-column>
        <a-table-column title="资产负责人" data-index="responsiblePersonName"> </a-table-column>
        <a-table-column title="资产位置(部门)" data-index="deptName"> </a-table-column>
        <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
        <a-table-column title="启用日期" data-index="startTime"> </a-table-column>
        <a-table-column title="资产状态">
          <template slot-scope="text">
            <DataDictFinder
              dictType="fixed_asset_status"
              :dictValue="text.status"
              iconType="badge"
            />
          </template>
        </a-table-column>
        <a-table-column title="备注" data-index="remark"> </a-table-column>
        <a-table-column title="操作" align="right" width="200px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                @click.prevent="receive(text)"
                v-if="text.status == 'fixed_asset_status_in_stock'"
                >确认接收</a
              >
              <a
                href="#"
                v-if="text.status !== 'fixed_asset_status_hand_overing' && text.status !== 'fixed_asset_status_in_stock'"
                @click.prevent="handover(text)"
                >资产移交</a
              >
              <a
                href="#"
                @click.prevent="$router.push($route.path + '/detail?id=' + text.id)"
                v-if="$getPermission($route.path + '/detail')"
                >详情</a
              >
              <a
                href="#"
                @click.prevent="$router.push($route.path + '/edit?id=' + text.id)"
                v-if="$getPermission($route.path + '/edit') && text.status !== 'fixed_asset_status_hand_overing' && !isPerson"
                >编辑</a
              >
              <a
                href="#"
                @click.prevent="deleteText(text)"
                style="color: #f5222d"
                v-if="$getPermission($route.path + '/edit') && text.status !== 'fixed_asset_status_hand_overing' && !isPerson"
                >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import { mapGetters } from "vuex";
import organization from "@/mixins/organization";
function accept(data){
  return request({
    url: "/office-service/fixed-asset/accept",
    data,
    method: 'post'
  });
}
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset/page",
    data,
    method: 'post'
  });
}
function deleteCategory(id) {
  return request({
    url: "/office-service/fixed-asset/delete/" + id,
    method: 'post'
  });
}

export default {
  mixins: [watermark,organization],

  data() {
    return {
      isPerson: 0,
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      selectedRowKeys: [],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("fixed_asset_status");
    }
  },

  mounted() {
    this.isPerson = this.$route.query.type;
    this.getList();
  },

  methods: {
    batchReceive() {
      const filterList = this.list.filter((item) =>
        this.selectedRowKeys.includes(item.id) && item.status === "fixed_asset_status_in_stock"
      );
      if(filterList.length === 0){
        this.$message.error("请选择需要接收的资产");
        return;
      }
      this.$confirm({
        title: "确认接收",
        content: `确认接收 ${filterList.length} 条记录吗？`,
        onOk: () => {
          accept(filterList.map((item) => item.id)).then(() => {
            this.getList();
          });
        },
      });
    },
    receive(text) {
      this.$confirm({
        title: "确认接收",
        content: `确认接收 "${text.assetCode}" 吗？`,
        onOk: () => {
          accept([text.id]).then(() => {
            this.getList();
          });
        },
      });
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys;
    },
    batchHandover() {
      const filterList = this.list.filter((item) =>
        this.selectedRowKeys.includes(item.id) && item.status !== "fixed_asset_status_hand_overing"
      );
      if(filterList.length === 0){
        this.$message.error("请选择需要移交的资产");
        return;
      }
      sessionStorage.setItem("handoverList", JSON.stringify(filterList));
      this.$router.push(this.$route.path + "/handover");
    },
    handover(text) {
      const filterList = [text];
      sessionStorage.setItem("handoverList", JSON.stringify(filterList));
      this.$router.push(this.$route.path + "/handover");
    },
    deleteText(text) {
      this.$confirm({
        title: "删除确认",
        content: `确认删除 "${text.subCategoryName}" 吗？`,
        onOk: () => {
          deleteCategory(text.id)
           .then(() => {
              this.getList();
            })
           .catch(() => {
              this.$message.error("删除失败");
            });
        },
      });
    },
    getList() {
      const { current, pageSize, form } = this;

      this.loading = true;
      if (Array.isArray(this.form.purchaseTime) && this.form.purchaseTime.length === 2) {
        form.procurementTimeBegin = this.form.purchaseTime[0].format("YYYY-MM-DD");
        form.procurementTimeEnd = this.form.purchaseTime[1].format("YYYY-MM-DD");
      }
      if (Array.isArray(this.form.startTime) && this.form.startTime.length === 2) {
        form.startTimeBegin = this.form.startTime[0].format("YYYY-MM-DD");
        form.startTimeEnd = this.form.startTime[1].format("YYYY-MM-DD");
      }
      fetchList({
        pageNum: current,
        pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    }
  },
};
</script>